"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
var _globalThis2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/global-this"));
// RWJS_ENV and RWJS_DEBUG_ENV
// are defined in Webpack.common.js and Vite.config.js

// @NOTE: do not use globalThis on the right side, because webpack cannot access these vars then
_globalThis2.default.RWJS_API_GRAPHQL_URL = RWJS_ENV.RWJS_API_GRAPHQL_URL;
_globalThis2.default.RWJS_API_URL = RWJS_ENV.RWJS_API_URL;
_globalThis2.default.__REDWOOD__APP_TITLE = RWJS_ENV.__REDWOOD__APP_TITLE;